import React from "react";
import styled from "styled-components";
import LargeContainer from "../LargeContainer";
import MainContainer from "../MainContainer";
import { NavLink as Link } from "react-router-dom";
import {
  HiOutlineUsers,
  HiOutlineSearch,
  HiOutlineHeart,
  HiOutlineShoppingBag,
} from "react-icons/hi";
const Navbar = ({ cartQty }) => {
  return (
    <LargeContainer
      bg="white"
      style={{
        boxShadow: "0px 2px 3px #ddd",
        position: "sticky",
        top: "0",
        zIndex: "10000",
      }}
    >
      <MainContainer
        bg="white"
        height=""
        valign="center"
        halign="space-between"
      >
        <Left>
          <Link to="/">
            <img src="/logo.png" alt="Logo" />
          </Link>
        </Left>
        <Middle>
          <NavLink to="/" exact>
            HOME
          </NavLink>
          <NavLink to="/shop">SHOP</NavLink>
          <NavLink to="/cart">CART</NavLink>
        </Middle>
        <Right>
          <Icons>
            <HiOutlineSearch />
          </Icons>
          <Icons>
            <Link to="/login" style={{ color: "#999" }}>
              <HiOutlineUsers />
            </Link>
          </Icons>
          <Icons>
            <HiOutlineHeart />
          </Icons>
          <Icons>
            <Link to="/cart" style={{ color: "#999" }}>
              <HiOutlineShoppingBag />
              <Bubble>{cartQty}</Bubble>
            </Link>
          </Icons>
        </Right>
      </MainContainer>
    </LargeContainer>
  );
};

const Left = styled.div`
  cursor: pointer;
  width: 4em;
  height: 4em;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    height: 100%;
    object-fit: scale-down;
  }
`;
const Middle = styled.div`
  display: flex;
`;
const Right = styled.div`
  display: flex;
`;
const NavLink = styled(Link)`
  text-decoration: none;
  font-size: 14px;
  font-weight: 400;
  padding: 1rem;
  color: #5e5c5c;
  text-decoration-line: none;

  border-bottom: 1px solid transparent;
  transition: color 0.5s, text-decoration-line 3s, scale 0.3s;
  cursor: pointer;

  :hover {
    scale: 1.1;
    color: #83aa4c;
    text-decoration-line: underline;
    text-underline-offset: 12px;
  }

  &.active {
    color: #83aa4c;
    text-decoration-line: underline;
    text-underline-offset: 12px;
  }
`;
const Icons = styled.div`
  position: relative;
  font-size: 1.5rem;
  padding: 0.8rem;
  color: #999;
  cursor: pointer;
  transition: color 0.5s;
  :visited {
    color: #999;
  }
  :hover {
    color: #83aa4c;
  }
`;

const Bubble = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  background-color: #83aa4c;
  height: 2em;
  width: 2em;
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 0.4em;
  right: 0em;
`;
export default Navbar;
